import { observer } from "@core-ui/react-mobx-state";
import { Flex } from "@core-ui/react-mui-core";

export const Header = observer(() => {

  return <Flex></Flex>
})